import * as React from "react";
import {cx} from "emotion";

import "./header.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {keyed}          from "@Common/react/keyed";
import {isNotEmpty}     from "@Common/utils/collections";
import {chain}          from "@Common/utils/fs";
import {oMapToArr}      from "@Common/utils/objects";

import {MenuInternalLink}        from "../../../common/components/internal-link";
import {PRODUCTS_MENU_ITEM_NAME} from "../../common/constants";

import {LeftNavItem} from "./left-nav/left-nav-item";
import {LnidDefault} from "./left-nav/left-nav-item-dropdown-default";
import {LnidProducts} from "./left-nav/products/left-nav-item-dropdown-products";
import {RightNav}     from "./right-nav/right-nav";

export const LayoutDesktopHeader = ({
    active=null,
    disableSuggestionsDialog=false,
    emulationPlugins=undefined,
    navBlock=undefined,
}) => cs(
    consumeContext("catSubStyle"),
    consumeContext("menus"),
    consumeContext("themeScheme"),
    consumeContext("userLevels"),
    ["catSubStyle", ({catSubStyle}, next) => next(!catSubStyle ? null : chain(
        catSubStyle?.value,
        (_) => oMapToArr(_, (v, k) => ({...v, id: k})),
        (_) => _.filter((cat) => cat.program),
        (_) => _.sort((a, b) => {
                return a.seq - b.seq;
        }),
    ))],

    ({catSubStyle, menus, themeScheme, userLevels}) => (
        <div
            // -zzz to avoid conflict with PHP page
            className={cx("header-zzz header-2w7", {"has-banner": themeScheme.xpresso.headerBanner}/*, css`
                //All font changes will be handled in the body unless we want to use different fonts in the header or footer
                font-family: Lato, "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
                font-weight: 400;
            `*/)}
            style={{background: themeScheme.xpresso.menuBackgroundColor,}}
        >
            {themeScheme.xpresso.headerBanner && (
                <div className="banner" style={{background: themeScheme.xpresso.headerColor}}>
                    <div className="restrict-width-1">
                        {themeScheme.xpresso.headerLogo && ( menus ? (
                            MenuInternalLink({
                                className: "logo-ov1",
                                to: "/",
                                "xd-qa-type": "logo",
                                "xd-qa-name": "company",
                                navBlock,
                                children: (
                                    <img alt={themeScheme?.companyName + " Logo"} src={themeScheme.xpresso.headerLogo} xd-qa-type="image" xd-qa-name="Logo"/>
                                ),
                            })
                        ) : (
                            <img alt={themeScheme?.companyName + " Logo"} className="logo-ov1" src={themeScheme.xpresso.headerLogo} xd-qa-type="image" xd-qa-name="Logo"/>
                        ))}
                        <img alt={themeScheme?.companyName + " Banner"} className="banner-ov1" src={themeScheme.xpresso.headerBanner} xd-qa-type="image" xd-qa-name="Banner"/>
                    </div>
                </div>
            )}
            <div className="main">
                <div className="restrict-width-1">
                    {!themeScheme.xpresso.headerBanner && (
                        menus ? (
                            MenuInternalLink({
                                to: `/`,
                                className: "logo-2ie",
                                "xd-qa-type": "image",
                                "xd-qa-name": "company logo",
                                navBlock,
                                children: (
                                    <img alt={themeScheme?.companyName + " Logo"} src={themeScheme.xpresso.headerLogo} xd-qa-type="image" xd-qa-name="Logo"/>
                                ),
                            })
                        ) : (
                            <img alt={themeScheme?.companyName + " Logo"} className="logo-2ie" src={themeScheme.xpresso.headerLogo} xd-qa-type="image" xd-qa-name="Logo"/>
                        )
                    )}

                    <div className="left-items-ov1">
                        {menus?.leftMenus.map((m, i) => cs(
                            keyed(i),
                            () => LeftNavItem({
                                ...m,
                                linkLabel: m.linkLabel.toUpperCase(),
                                active: m.linkLabel.toLowerCase() === active,
                                rDropdown: m.name === PRODUCTS_MENU_ITEM_NAME ? (
                                    (left) => LnidProducts({left, navBlock})
                                ) : (
                                    isNotEmpty(m.subMenu) && ((left) => LnidDefault({
                                        items: m.linkLabel.toUpperCase() !== 'PROGRAMS' ? m.subMenu : [
                                            ...m.subMenu,
                                            ...catSubStyle ?? [],
                                        ],
                                        left,
                                        navBlock,
                                    }))
                                ),
                                navBlock,
                            })
                        ))}
                        {menus && !menus.leftMenus.find((m) => m.linkLabel.toUpperCase() === 'PROGRAMS') && isNotEmpty(catSubStyle) && (
                            LeftNavItem({
                                linkLabel: 'PROGRAMS',
                                active: false,
                                rDropdown: (left) => LnidDefault({
                                    items: catSubStyle, left,
                                    navBlock,
                                }),
                                navBlock,
                            })
                        )}
                    </div>

                    {RightNav({
                        showEmulation: ["orders", "my listings", "product-options", "manage-headshots", "subscriptions"].includes(active),
                        showBranchSwitcher: userLevels?.multiBranch && ["catSubcatStyle", "omniSearch", "profile"].includes(active),
                        emulationPlugins,
                        disableSuggestionsDialog,
                        navBlock,
                    })}

                </div>
            </div>
        </div>
    ),
);
